import ColorsSet, { colorYellow } from "../../../../../common/utils/StarColorSet";

export default function StarColumnRenderer(params) {
  function getStar() {
    const starElement = document.createElement("i");
    starElement.id = "star";
    starElement.style.cursor = "pointer";

    if (params.data?.row_id == "+") {
      return document.createElement("div");
    }

    if (Object.keys(ColorsSet).includes(params.value) || Object.keys(colorYellow).includes(params.value)) {
      starElement.className = "fas fa-star";
      var star_color = params.store.getStarColumnHashValue(params.value)
      starElement.style.color = star_color.color;
    } else {
      starElement.className = "far fa-star";
    }
    return starElement;
  }

  function clickHandler(event) {
    if (params.data?.row_id != "" && (!params.value || params.value == "" || typeof params.value == "undefined")) {
     let column_id = "column_" + params.columnId
     params.store.refreshStarCell(column_id, "yellow", params.node);
    }
    if (params.api.getEditingCells().length > 0) {
      params.api.clearRangeSelection();
      params.api.stopEditing();
    }
    let rowIndex = '';
    const firstDisplayedRowIndex = params?.columnApi?.columnController?.gridApi.getFirstDisplayedRow();
    const lastDisplayedRowIndex = params?.columnApi?.columnController?.gridApi.getLastDisplayedRow();
    for (let i = firstDisplayedRowIndex; i <= lastDisplayedRowIndex; i++) {
      var rowNode = params?.columnApi?.columnController?.gridApi?.getDisplayedRowAtIndex(i);
      if (params?.data?.row_id == rowNode?.data?.row_id) {
        rowIndex = rowNode?.rowIndex ?? '';
        break;
      }
    }
    params.api.startEditingCell({
      colKey: params.colDef.colId,
      rowIndex: ((rowIndex && rowIndex !== '') || rowIndex == 0) ? rowIndex : params.rowIndex,
    });
  }

  function dbClickHandler(event) {
    const canEdit = window.appStore?.containerStore?.permissions?.canEdit(params?.colDef?.cellRendererParams?.columnId, params?.data)[0];
    if(!canEdit) {
      const message = params?.colDef?.store?.containerStore?.permissions.canEdit(
        params?.colDef?.cellRendererParams?.columnId,
        params?.node?.data
      )[1];
      window.appStore.notificationStore.showNotification(
        message,
        "caution"
      );
    }
    if (params.node.data.row_id && canEdit) {
      if (params.colDef.cellEditorParams.columnOptions?.is_star_column == true) {
        if (params.api.getEditingCells().length > 0) {
          params.api.clearRangeSelection();
          params.api.stopEditing();
        }
        let newnewval = params.value ? "" : "yellow";
        params.store.handleCellValueChanged({
          colDef: params.column.colDef,
          api: params.api,
          node: params.node,
          newValue: newnewval,
          oldValue: params.value,
        });
      }
    }
  }


  let starWrapperElement = document.createElement("div");
  starWrapperElement.className = "starRenderer";
  starWrapperElement.style = `width: ${Number(params.colDef.width) - 2}px; 
                              height: ${Number(params.node.rowHeight) - 4}px; 
                              color: grey; 
                              font-size: 1.3rem;`;
  let starElement = getStar();
  starElement.onclick = clickHandler;
  starWrapperElement.ondblclick = dbClickHandler;
  starWrapperElement.appendChild(starElement);

  return starWrapperElement;
}
